module.exports = __webpack_public_path__ + "assets/d2422f2d34dd3d424e42b0f0ed8aad28.png";